import { StyleSheet } from 'react-native';
import { BLUE_COLOR } from 'coooltv-js-shared/src/styles/common';

const homeScreenStyles = StyleSheet.create({
    image_wrapper: {
        marginLeft: '-1px',
        alignSelf: 'center',
    },
    image_container: {
        paddingTop: 60,
        paddingHorizontal: 30,
    },
    text: {
        fontSize: 16,
        textAlign: 'center',
        marginVertical: 20,
        color: BLUE_COLOR,
    },
    device_text: {
        fontSize: 16,
        textAlign: 'center',
        marginBottom: 10,
        color: BLUE_COLOR,
        alignSelf: 'center',
        minHeight: 64.5,
        maxWidth: 195,
        wordBreak: 'break-all',
    },
});

export default homeScreenStyles;
